<template>
  <div id="the-artist">
    <b-container class="the-artist-container">
      <Header title="The Artist" />
      <ImageGallery
        style="margin-top: 40px"
        :data="[
          require('@/assets/images/galleries/deguzman/Louis-Image-01.jpg'),
          require('@/assets/images/galleries/deguzman/Louis-Image-02.jpg'),
          require('@/assets/images/galleries/deguzman/Louis-Image-03.jpg'),
        ]"
        :idString="'theartist'"
      />
      <h4>Louis De Guzman</h4>
      <p>
        Louis De Guzman is an award-winning visual artist and designer who
        creates artwork that merges his past with his present. Over the last
        decade De Guzman has proved himself as a true multidisciplinary artist
        by blending both traditional and experimental techniques in his work.
      </p>
      <p>
        His signature geometric abstraction style often blends together images
        and stories that represent his family's immigrant journey, as well as
        his own experience as a second-generation Filipino American. De Guzman's
        career has led him to create well-received original bodies of work as
        well as interpretations of licensed intellectual property.
      </p>
      <p>
        To learn more about Louis De Guzman or to view his work, visit
        <a
          href="https://www.louisdeguzman.com"
          target="_blank"
          v-ePitchTracking="{
            site: 'kate',
            category: 'Link',
            label: 'Kate Lynn Lewis',
          }"
          >www.louisdeguzman.com.</a
        >
      </p>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
export default {
  name: "TheArtist",
  components: {
    ImageGallery,
    Header,
  },
};
</script>

<style lang="scss" scoped>
#the-artist {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-artist-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media (max-width: $md) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .italic {
    font-family: AvenirNext-Medium-Italic;
    font-size: 16px;
    color: #3e3e3e;
    text-align: center;
    line-height: 25px;
    width: 587px;
    max-width: 100%;
    &:after {
      content: url("~@/assets/images/icons/Close-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-left: 8px;
      transform: scale(0.5);
    }
    &:before {
      content: url("~@/assets/images/icons/Open-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-right: 8px;
    }
  }
  h4 {
    font-family: "Poppins-Bold";
    font-size: 20px;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  p {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: center;
    line-height: 23px;
    margin-bottom: 20px;
    width: 852px;
    max-width: 100%;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: $red;
    text-decoration: none;
  }
}
</style>
